module.exports = __webpack_public_path__ + "img/image 1128@2x.b1061714.png";